/**
 * Trial Lesson Progress Manager
 * Saves and restores user progress in the trial lesson when they're not authenticated
 */

const STORAGE_KEY = 'trialLessonProgress';

export const saveTrialProgress = (section, data) => {
  try {
    const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    existing[section] = {
      ...data,
      timestamp: Date.now()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    console.log(`✅ Trial progress saved for ${section}:`, data);
  } catch (error) {
    console.error('Error saving trial progress:', error);
  }
};

export const getTrialProgress = (section) => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    
    const data = JSON.parse(stored);
    const sectionData = data[section];
    
    // Return null if data is older than 24 hours
    if (sectionData && sectionData.timestamp) {
      const hoursSinceLastSave = (Date.now() - sectionData.timestamp) / (1000 * 60 * 60);
      if (hoursSinceLastSave > 24) {
        console.log(`⏱️ Trial progress for ${section} expired (${hoursSinceLastSave.toFixed(1)}h old)`);
        return null;
      }
    }
    
    console.log(`📦 Trial progress loaded for ${section}:`, sectionData);
    return sectionData || null;
  } catch (error) {
    console.error('Error loading trial progress:', error);
    return null;
  }
};

export const clearTrialProgress = (section = null) => {
  try {
    if (section) {
      // Clear specific section
      const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      delete existing[section];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
      console.log(`🗑️ Trial progress cleared for ${section}`);
    } else {
      // Clear all trial progress
      localStorage.removeItem(STORAGE_KEY);
      console.log('🗑️ All trial progress cleared');
    }
  } catch (error) {
    console.error('Error clearing trial progress:', error);
  }
};

export const hasTrialProgress = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return !!stored && Object.keys(JSON.parse(stored)).length > 0;
  } catch {
    return false;
  }
};
